/** @jsx jsx */
import { Button, ChevronDownIcon, ChevronUpIcon } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

interface CollapsibleButtonProps {
  collapsed: boolean;
  toggleCollapsed: () => void;
}

export const CollapsibleButton: FC<CollapsibleButtonProps> = ({ collapsed, toggleCollapsed }) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      iconLeft={collapsed ? <ChevronDownIcon /> : <ChevronUpIcon />}
      onClick={toggleCollapsed}
    />
  );
};
